module.exports = __webpack_public_path__ + "static/Ben-87c9f543631f970bdbe5974b6ef5ece7.jpg";